import React, { useEffect, useState } from 'react'
import { testimonials } from '../../assets/data/Testimonials'
import SectionHeading from '../SectionHeading/SectionHeading'
import Slider from '../Slider/Slider'
import { FaAngleRight, FaAngleLeft } from 'react-icons/fa'
import './Testimonials.css'

const Testimonials = () => {
    const [current, setCurrent] = useState(0)
    const [clicked, setClicked] = useState(true)
    const max = testimonials.length - 1
    const swipeRight = () => {
        setCurrent(current===max ? 0 : current+1)
        setClicked(false)
    }
    const swipeLeft = () => {
        setCurrent(current===0 ? max : current-1)
        setClicked(false)
    }
    useEffect(() => {
        clicked &&
        setTimeout(async function() {
            setCurrent(current===max ? 0 : current+1)
        }, 2500)
    }, [current, max, clicked])
    return (
        <section className="testimonials" name="testimonials">
            <SectionHeading heading="Testimonials" />
            {
                testimonials.map((testimonial, index) => {
                    return (current===index && <Slider key={index} {...testimonial} />)
                })
            }
            <FaAngleRight onClick={swipeRight} className="right-arrow arrow" />
            <FaAngleLeft onClick={swipeLeft} className="left-arrow arrow" />
        </section>
    )
}

export default Testimonials
